var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('facebook-sign-in-button',{attrs:{"disabled":_vm.isConnected},on:{"sign-in":_vm.facebookSignIn}},[(_vm.isConnected)?_c('span',[_vm._v("Facebook account connected")]):_c('span',[_vm._v("Connect Facebook Account")])])}
var staticRenderFns = []

export { render, staticRenderFns }